import React from 'react';
import MDCTextField from './MDCTextField.js.jsx';
import MDCCheckbox from './MDCCheckbox.js.jsx';
import classNames from 'classnames';
import tenantFormStyles from '../../../stylesheets/management_site/tenantForm.module.scss';
import newLeaseModalStyles from '../../../stylesheets/management_site/newLeaseModal.module.scss';

const TenantFormContactSection = ({
  tenantIndex,
  allowOnlineAccess,
  onAllowOnlineAccessChange,
  showOnlineAccessColumn,
}) => {
  return (
    <div className={newLeaseModalStyles.newLeaseModalSection}>
      <div className={newLeaseModalStyles.sectionHeader}>
        <h3 className={newLeaseModalStyles.sectionTitle}>
          Contact Information
        </h3>
      </div>
      <div className={newLeaseModalStyles.sectionContent}>
        <div className={classNames('pm-flex', tenantFormStyles.contactInfoRow)}>
          <div className={tenantFormStyles.expandableNameFields}>
            <div className="pm-flex pm-flex-2">
              <MDCTextField
                label="Email Address"
                name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_attributes][email]`}
                id={`lease_tenant_lease_relationships_attributes_${tenantIndex}_tenant_attributes_email`}
                type="email"
              />
              <MDCTextField
                label="Phone Number"
                name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][tenant_attributes][phone]`}
                id={`lease_tenant_lease_relationships_attributes_${tenantIndex}_tenant_attributes_phone`}
                type="tel"
              />
            </div>
          </div>

          <div className={tenantFormStyles.allowOnlineAccessCheckbox}>
            {showOnlineAccessColumn && (
              <MDCCheckbox
                label="Allow Online Access"
                name={`lease[tenant_lease_relationships_attributes][${tenantIndex}][allow_online_access]`}
                id={`allow_online_access_${tenantIndex}`}
                className={classNames(
                  'allow-online-access-col',
                  'allow_online_access_checkbox'
                )}
                checked={allowOnlineAccess}
                onChange={onAllowOnlineAccessChange}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TenantFormContactSection;
